import { Suspense } from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { GoogleOAuthProvider } from "@react-oauth/google"
import { Helmet, HelmetProvider } from "react-helmet-async"

import App from "./app"
import { CONFIG } from "./config-global"
import { ErrorBoundary } from "./routes/sections/errorBoundary"
// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
    <GoogleOAuthProvider clientId={CONFIG.site.googleClientId}>
        <HelmetProvider>
            <Helmet>
                <link rel="icon" type="image/png" href={CONFIG.site.icon} />
            </Helmet>
            <ErrorBoundary>
                <BrowserRouter basename={CONFIG.site.basePath}>
                    <Suspense>
                        <App />
                    </Suspense>
                </BrowserRouter>
            </ErrorBoundary>
        </HelmetProvider>
    </GoogleOAuthProvider>
)
